<div
  class="w-full overflow-hidden rounded-2xl border border-[#e5e7eb] bg-white shadow-xl dark:border-surface-3 dark:bg-surface-1"
  (click)="$event.stopPropagation()">
  <div class="relative px-6 pb-2 pt-6">
    <button type="button" (click)="close()"
      class="absolute right-4 top-4 inline-flex h-8 w-8 items-center justify-center rounded-full bg-[#f2f5f8] text-[#7d7d93] transition hover:bg-[#e8ecf1] dark:bg-surface-3 dark:text-ink-soft dark:hover:bg-surface-3"
      aria-label="Close">
      <app-icon-v2 name="x" size="16"></app-icon-v2>
    </button>

    <h3 class="pr-10 text-left text-[20px] font-bold leading-snug text-[#141437] dark:text-white">
      {{ title }}
    </h3>

    <p class="mt-4 text-left text-[14px] text-[#7d7d93] dark:text-ink-muted">Total Amount</p>
    <p class="text-[28px] font-bold leading-tight text-[#141437] dark:text-white">
      {{ totalAmount | currency }}
    </p>

    <div class="mt-5 space-y-3">
      @for (source of sources; track source.id) {
        <button type="button"
          class="flex w-full items-center justify-between gap-3 rounded-[12px] border px-4 py-3 text-left transition"
          [ngClass]="selectedSource === source.id
            ? 'border-[#7c3aed] bg-[#faf5ff] dark:border-purple-400 dark:bg-purple-500/10'
            : 'border-[#e5e7eb] bg-white hover:border-[#d1d5dc] dark:border-surface-3 dark:bg-surface-1 dark:hover:border-line-strong'"
          (click)="selectSource(source.id)">
          <div class="flex min-w-0 items-center gap-3">
            <span
              class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-[10px] bg-[#f3e8ff] text-[#7c3aed] dark:bg-purple-500/10 dark:text-[#c4b5fd]">
              <app-icon-v2 [name]="source.id === 'card' ? 'credit-card' : 'landmark'" size="18"></app-icon-v2>
            </span>
            <span class="min-w-0">
              <span class="block text-[15px] font-semibold text-[#141437] dark:text-white">{{ source.label }}</span>
              <span class="block text-[13px] text-[#7d7d93] dark:text-ink-muted">
                Available: {{ source.availableAmount | currency }}
              </span>
            </span>
          </div>
          <span
            class="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-[4px] border transition"
            [ngClass]="selectedSource === source.id
              ? 'border-[#7c3aed] bg-[#7c3aed]'
              : 'border-[#d1d5dc] bg-white dark:border-line-strong dark:bg-surface-0'">
            @if (selectedSource === source.id) {
              <app-icon-v2 name="check" size="12" class="text-white"></app-icon-v2>
            }
          </span>
        </button>
      }
    </div>
  </div>

  <div class="px-6 pb-6 pt-4">
    <app-button type="button" variant="primary" size="lg" className="!w-full !rounded-[10px]"
      (click)="confirm()" [disabled]="!selectedSource || confirmDisabled">
      {{ confirmLabel }}
    </app-button>
  </div>
</div>
